<div class="card-spacer">
  <div fxLayout="row" fxLayoutAlign="start center">
    <span *ngIf="!data.isMobileMode" style="margin-left: 8px; margin-top: 16px" class="mat-title mat-title-spacing">
      <mat-icon class="list-icon">{{ data.icon }}</mat-icon>
      <span *ngIf="data.showListCount" style="vertical-align: middle; margin-left: 8px" [matBadge]="dataSource.data?.length"
        matBadgeColor="primary" matBadgeOverlap="false">{{ data.title }}
      </span>
      <span *ngIf="!data.showListCount" style="vertical-align: middle; margin-left: 8px">
        {{ data.title }}
      </span>
    </span>
    <span fxFlex></span>
    <span>
      <app-search-bar [searchValue]="data.dataSourceConfig?.filter" (searchFilter)="applyFilter($event)">
      </app-search-bar>
    </span>
    <button *ngIf="data.showAddButton" mat-icon-button matTooltip="ADD" [disabled]="data.isLoading" (click)="add()">
      <mat-icon>add</mat-icon>
    </button>
    <button *ngIf="!data.useServerSideData" class="test" mat-icon-button matTooltip="FILTER"
      [disabled]="data.isLoading" (click)="selectFilterColumns()">
      <mat-icon>filter_list</mat-icon>
    </button>
  </div>
</div>
<mat-divider></mat-divider>
<app-empty-state [isMobileMode]="data.isMobileMode" [show]="dataSource.filteredData.length === 0" [showAction]="false"
  title="No items found" subTitle="Please enter a search value above" icon="search">
</app-empty-state>
<div [hidden]="dataSource.filteredData.length === 0">
  <table mat-table matSort (matSortChange)="sortChange($event)" [dataSource]="dataSource">
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <div *ngIf="data.allowMultiSelect">
          <mat-checkbox class="select-checkbox" (change)="$event ? masterToggle() : null"
            [checked]="selectedListItems.hasValue() && isAllSelected()"
            [indeterminate]="selectedListItems.hasValue() && !isAllSelected()">
          </mat-checkbox>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox class="select-checkbox" (click)="$event.stopPropagation()"
          (change)="$event ? selectItem(row) : null" [checked]="selectedListItems.isSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container>
    <div *ngFor="let column of data.dataSourceConfig?.columns">
      <div *ngIf="column !== 'select'">
        <ng-container matColumnDef="{{ column }}">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column.toUpperCase() }}</th>
          <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
        </ng-container>
      </div>
    </div>
    <tr mat-header-row *matHeaderRowDef="data.dataSourceConfig?.columns"></tr>
    <tr mat-row *matRowDef="let row; columns: data.dataSourceConfig?.columns"></tr>
  </table>
  <div class="card-spacer">
    <mat-paginator (page)="page($event)" [pageSizeOptions]="data.dataSourceConfig?.pageSizeOptions"
      [hidePageSize]="data.isMobileMode">
    </mat-paginator>
  </div>
</div>
<mat-divider></mat-divider>
<div style="margin-top: 24px" fxLayout="row" fxLayoutGap="16px">
  <span fxFlex></span>
  <button type="button" mat-flat-button color="accent" (click)="cancel()">CANCEL</button>
  <button [disabled]="selectedListItems.selected.length === 0" type="button" mat-flat-button (click)="select()"
    color="primary">SELECT</button>
</div>
